import axios from "axios";
import { useKeycloak } from "@react-keycloak/web";

const axiosInstance = axios.create({
  baseURL: "https://iamposdev.ig-nl.com/api",
  // baseURL: "http://localhost:8000/api/",
  timeout: 5000,
  
  headers: {
    Authorization: "Bearer " + localStorage.getItem("access_token"),
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    let access_token = localStorage.getItem('access_token');
    config.headers.Authorization = `Bearer ${access_token}`;
    return config;
  }
)

axiosInstance.interceptors.response.use(
  
  (response) => response,
  (config) => {
    const access_token = localStorage.getItem('access_token');
    console.log("request config", config);
    return config;
  },

  (error) => {
    const originalRequest = error.config;
    if (localStorage.getItem("access_token") == null){
      window.location = "/app/home";
    }
    // if (localStorage.getItem("refresh_token") === null) {
    //   window.location = "/app/login/";
    // }

    if (error.response.status === 404) {
      window.location = "/app/not-found/";
    }

    if (error.response.status === 403) {
      window.location = "/app/not-found/";
    
    // if (
    //   error.response.status === 403 &&
    //   error.response.statusText === "Unauthorized"
    // ) {
    //   // console.log(keycloak.tokenParsed.preferred_username);
    //   console.log("response is unauthorized ");
    //   let access_token = localStorage.getItem("access_token");

    //   axiosInstance
    //     .get("/onderhoudstaken/", { access_token: access_token })
    //     .then((response) => {
    //       // localStorage.setItem("access_token", response.data.access);
         

    //       axiosInstance.defaults.headers["Authorization"] =
    //         "Bearer " + access_token;
    //       originalRequest.defaults.headers["Authorization"] =
    //         "Bearer " + access_token;
    //       return axiosInstance;
    //     })
    //     .catch((e) => {
    //       // window.location = window.location.href;
    //       console.log(e);
    //     });
    // }    

    // if (
    //   error.response.status === 401 &&
    //   error.response.statusText === "Unauthorized"
    // ) {
    //   // console.log(keycloak.tokenParsed.preferred_username);
    //   console.log("response is unauthorized ");
    //   let refresh_token = localStorage.getItem("refresh_token");

    //   axiosInstance
    //     .post("/token/refresh/", { refresh: refresh_token })
    //     .then((response) => {
    //       localStorage.setItem("access_token", response.data.access);
    //       localStorage.setItem("refresh_token", response.data.refresh);

    //       axiosInstance.defaults.headers["Authorization"] =
    //         "JWT " + response.data.access;
    //       originalRequest.defaults.headers["Authorization"] =
    //         "JWT " + response.defaults.headers;
    //       return axiosInstance;
    //     })
    //     .catch((e) => {
    //       // window.location = window.location.href;
    //       console.log(e);
    //     });
    
 
 
  }
    return Promise.reject(error);
  }
);

export default axiosInstance;
